// extracted by mini-css-extract-plugin
export var closeButton = "_ll-2";
export var closeButtonIcon = "_ll-3";
export var lightboxContent = "_ll-1";
export var lightboxOverlay = "_ll-0";